import { FC } from "react"
import { TextAlignProps } from "../../contactAndSafetyInfo/types";
import ManufacturerContactAndSafetyInfo from "../manufacturerContactAndSafetyInfo";


const AuthMaunfacturerSubHeader: FC = (): JSX.Element => {

  return (
    <div className="row">
        <ManufacturerContactAndSafetyInfo textColor="primary" alignText={TextAlignProps.TEXT_END} />
    </div>
  );
};

export default AuthMaunfacturerSubHeader;
